<body 
  class="min-h-screen grid bg-cover bg-center bg-no-repeat bg-fixed"
  :style="{ backgroundImage: `url(${bgImage})` }"
>
  <div
    class="max-w-95 max-h-120 my-[15%] mx-auto p-6 border border-gray-200 bg-white/60 rounded-lg font-sans shadow-[0_10px_25px_rgba(0,0,0,0.15)] backdrop-blur-sm">
    <!-- Alert Messages -->
    <p v-if="successMessage"
      class="p-3 -my-19 rounded-md text-sm mb-4 bg-emerald-50 text-emerald-800 border border-emerald-200">
      {{ successMessage }}
    </p>
    <p v-if="errorMessage" class="p-3 -my-19 rounded-md text-sm mb-4 bg-red-50 text-red-800 border border-red-200">
      {{ errorMessage }}
    </p>
    <!-- Alert Messages -->
    <!-- <img
        src="/kor01.png"
        class="h-11 w-auto object-contain mb-5 -my-18"
    /> -->
    
    <h1 class="text-2xl font-bold mb-4 text-gray-800 text-center"><b>Login Form</b></h1>

    <form @submit.prevent="handleLogin" class="space-y-4">
      <!-- Email Field -->
      <div class="flex flex-col">
        <label class="mb-1.5 text-sm text-gray-700 font-medium">Username</label>
        <input v-model="form.username" type="text" required
          class="w-full px-3 py-2 border border-gray-300 rounded-md box-border focus:outline-none focus:ring-2 focus:ring-[#42b883] focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed" />
      </div>

      <!-- Password Field with Show/Hide Toggle -->
      <div class="flex flex-col">
        <label class="mb-1.5 text-sm text-gray-700 font-medium">Password</label>
        <div class="relative flex items-center">
          <input v-model="form.password" :type="showPassword ? 'text' : 'password'" required
            class="w-full pl-3 pr-10 py-2 border border-gray-300 rounded-md box-border focus:outline-none focus:ring-2 focus:ring-[#42b883] focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed" />
          <button type="button"
            class="absolute right-2 bg-transparent border-0 cursor-pointer flex items-center justify-center text-gray-500 p-1 rounded hover:text-[#42b883] transition-colors"
            @click="toggleShowPassword" :aria-label="showPassword ? 'Hide password' : 'Show password'">
            <!-- SVG Eye Icons -->
            <svg v-if="!showPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
              <circle cx="12" cy="12" r="3" />
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
              <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
              <path d="M6.61 6.61A13.52 13.52 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
              <line x1="2" x2="22" y1="2" y2="22" />
            </svg>
          </button>
        </div>
      </div>

      <!-- IMAGE PUZZLE CAPTCHA -->
      <div class="flex flex-col">
        <!-- Canvas Stage -->
        <div class="relative w-full h-25 rounded-md overflow-hidden mb-2.5 bg-slate-100">
          <canvas ref="bgCanvas" width="332" height="100" class="w-full h-full block"></canvas>
          <canvas ref="pieceCanvas" width="332" height="100"
            class="absolute top-0 left-0 w-full h-full pointer-events-none z-10"
            :style="{ transform: `translateX(${sliderLeft}px)` }"></canvas>
        </div>

        <!-- Drag Control Track -->
        <div ref="sliderTrack"
          class="relative w-full h-10 border rounded-md overflow-hidden select-none box-border transition-colors duration-200"
          :class="isVerified ? 'bg-green-100 border-green-300' : 'bg-slate-100 border-slate-300'">
          <!-- Fill overlay -->
          <div class="absolute left-0 top-0 h-full bg-[#42b883] opacity-25" :style="{ width: sliderLeft + 'px' }"></div>

          <!-- Text -->
          <div class="absolute inset-0 flex items-center justify-center text-xs pointer-events-none transition-colors"
            :class="isVerified ? 'text-green-700 font-semibold' : 'text-slate-500 font-medium'">
            {{ isVerified ? 'Verified ✓' : 'Drag slider to fit the puzzle' }}
          </div>

          <!-- Thumb Handle -->
          <div
            class="absolute top-0 left-0 w-10 h-9.5 border rounded flex items-center justify-center text-sm shadow transition-colors z-20"
            :class="isVerified 
            ? 'bg-green-500 text-white border-green-600 cursor-default' 
            : 'bg-white text-slate-700 border-slate-300 cursor-grab active:cursor-grabbing active:bg-slate-50'"
            :style="{ transform: `translateX(${sliderLeft}px)` }" @mousedown="startDrag" @touchstart="startDrag">
            ➔
          </div>
        </div>
      </div>

      <!-- Submit Button -->
      <!-- class="w-full py-2.5 px-4 bg-[#42b883] hover:bg-[#3aa876] text-white border-0 rounded-md text-base cursor-pointer font-medium transition-colors disabled:opacity-60 disabled:cursor-not-allowed" -->
      <button type="submit"
        class="w-full py-2.5 px-4 bg-[#4c56c7] hover:bg-[#2c37b8] text-white border-0 rounded-md text-base cursor-pointer font-medium transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
        :disabled="isLoading || !isVerified">
        <span v-if="isLoading">Signing in...</span>
        <span v-else>Sign In</span>
      </button>
    </form>
  </div>
<!-- 
  <img 
    src="/public/polwan.png?t=1789529041652" 
    alt="" 
    class="w-3/5 z-10 justify-self-center -mr-200 opacity-100" 
    style="position: fixed;align-self: anchor-center;margin-top: 16%;transform: scaleX(-1);"
  > -->
</body>